// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import withIconProps from '../withIconProps';

import ViewEyeOutline from '../_raw/ui/view_eye_outline.svg';

export default withIconProps(ViewEyeOutline);
